import { demoFile, component, componentWithVariants, variant, story, CLICK, POPUP } from 'system/demo';
import { ModDashboardUserProfileInformation, ModDashboardUserStatistics } from 'open-modules/zdf/component/moddashboard/moddashboarduserprofile';
import { modDashboardDemoData } from '../../../../../demo/zdf/moddashboard/moddashboard.data';
import { SuspensionObject, SuspensionStatusType } from '../../suspension/suspension';
import { ProfileModerationData } from '../moddashboardProfileUtils';

demoFile('open-modules/zdf/component/moddashboard/moddashboarduserprofile');

const demoWarning_1: SuspensionObject = {
    key: "w1",
    recipientKey: "a",
    time: 1000,
    suspensionType: SuspensionStatusType.WARNED,
    objectKey: "c1"
}

const demoWarning_2: SuspensionObject = {
    key: "w2",
    recipientKey: "a",
    time: 1000,
    suspensionType: SuspensionStatusType.WARNED,
    objectKey: "c2"
}



const userProfileDataNoEntries: ProfileModerationData = {
    preview: {},
    memberSince: 0,
    commentCount: 0,
    rejectedCommentCount: 0,
    flagsGivenCount: 0,
    flagsReceivedCount: 0,
    suspensions: {},
};

const userProfileDataOneEntry: ProfileModerationData = {
    preview: {},
    memberSince: 0,
    commentCount: 1,
    rejectedCommentCount: 1,
    flagsGivenCount: 1,
    flagsReceivedCount: 1,
    suspensions: {
        w1: demoWarning_1
    },
};

const userProfileDataMultipleEntries: ProfileModerationData = {
    preview: {},
    memberSince: 0,
    commentCount: 2,
    rejectedCommentCount: 2,
    flagsGivenCount: 2,
    flagsReceivedCount: 2,
    suspensions: {
        w1: demoWarning_1,
        w2: demoWarning_2
    },
};

component('ModDashboardUserProfileInformation', ModDashboardUserProfileInformation, {
    args: { userId: modDashboardDemoData.demoAuthors.c.key },
    state: { serverCall: modDashboardDemoData.serverCalls },
});


componentWithVariants('ModDashboardUserStatistics', ModDashboardUserStatistics, {}, [
    variant('No entries', { args: { userProfileData: userProfileDataNoEntries} }),
    variant('One entry', { args: { userProfileData: userProfileDataOneEntry } }),
    variant('Multiple entries', { args: { userProfileData: userProfileDataMultipleEntries } }),
]);


componentWithVariants('ModDashboardUserProfileInformation (actions)', ModDashboardUserProfileInformation, {
    state: {
        serverCall: modDashboardDemoData.serverCalls,
        modulePublic: { moderation: { queue: modDashboardDemoData.modTaskQueues.thread1 } },
    },
}, [
    variant('Blockable user', 
        { args: { userId: modDashboardDemoData.demoAuthors.c.key } },
        [story(
            "Block user", [CLICK("Block user"), POPUP(CLICK("Block user"))]
        )]

    ),
    variant('Unblock user', { args: { userId: modDashboardDemoData.demoAuthors.d.key } },
        [story(
            "Unblock user", [CLICK("Unblock user"), POPUP(CLICK("Unblock user"))]
        )]
    )
]);
